import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { WEBSITE_API } from '../api/website-api'
import { WebsiteId } from '../types/website-interface'

interface WebsitePAgeListItemInterface {
  pageContentId: number
  name: string
}

export function useWebsitePageListAll(
  websiteId: WebsiteId | undefined,
  shouldFetch: boolean = true,
) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, WebsitePAgeListItemInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: websitePageListAll, mutate } = useControlledSwr(
    [`${WEBSITE_API}/websites/${websiteId}/list-all-pages`, RequestModuleEnum.Websites],
    fetcher,
    undefined,
    shouldFetch && !!user && !!websiteId,
  )

  return { websitePageListAll, mutate }
}
